import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { duckify, filterDuck, singleDuck } from 'utils/duckify';
import { modals, tasks as tasksDuck, users as usersDuck } from 'ducks/index';

import FontAwesome from 'utils/FA';
import WidgetHeader from 'components/WidgetHeader/WidgetHeader';
import AddReminder from './AddReminder';
import ReminderList from './ReminderList';

const ContactReminders = ({
  contactId,
  currentUser,
  onDestroy,
  onSave,
  reminders,
  users
}) => {
  const [showAdd, setShowAdd] = useState(false);

  return (
    <div>
      <WidgetHeader text='Reminders' />
      <OverlayTrigger
        placement='top'
        overlay={<Tooltip id='reminder-add'>Add a new reminder</Tooltip>}
      >
        <button type='button' className='reminder-add' onClick={() => setShowAdd(!showAdd)}>
          <FontAwesome icon={faPlusCircle} />
        </button>
      </OverlayTrigger>

      <div className='reminder-tagline'>Upcoming tasks and reminders</div>

      {
        showAdd && (
          <AddReminder
            contactId={contactId}
            currentUser={currentUser}
            onClose={() => setShowAdd(false)}
            onSubmit={(values) => onSave(`contact_id=${contactId}`)(values) && setShowAdd(false)}
            users={users}
          />
        )
      }

      <ReminderList
        onDestroy={onDestroy(`contact_id=${contactId}`)}
        onSave={onSave(`contact_id=${contactId}`)}
        reminders={reminders}
        users={users}
      />
    </div>
  );
};

ContactReminders.defaultProps = {
  currentUser: { id: '' },
  onDestroy: () => false,
  onSave: () => false,
  reminders: [],
  contactId: '',
  users: []
};

ContactReminders.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.string
  }),
  onDestroy: PropTypes.func,
  onSave: PropTypes.func,
  reminders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ),
  contactId: PropTypes.string,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  )
};

const mapDucksToProps = ({ contactId }) => ({
  currentUser: singleDuck(usersDuck, 'current'),
  reminders: filterDuck(tasksDuck, { contact_id: contactId }),
  users: filterDuck(usersDuck, { type: 'Admin' })
});

const mapDispatchToProps = (dispatch) => ({
  onDestroy: (stateKey) => (task) => dispatch(modals.actions.show('VerificationModal', {
    title: 'Are you sure?',
    message: (
      <p>
        Deleting this reminder will&nbsp;
        <strong>permanently</strong>
        &nbsp;remove it from the system. If you have completed this task, instead use
        the checkbox to mark the item completed.
      </p>
    ),
    onConfirm: () => dispatch(tasksDuck.actions.remove(task, stateKey)).catch(() => false)
  })),
  onSave: (stateKey) => (task) => dispatch(tasksDuck.actions.save(task, {}, stateKey))
});


export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(ContactReminders);
